export enum SystemType {

  NONE= 'NONE',
  GS_WEB= 'GS_WEB',
  DIRECTORY= 'DIRECTORY'

}
